import type { IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputSelectDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        defaultText: "<?", // A default element is always rendered, text can be customized here
        hideDefault: "<",
        irLabel: "<",
        ngModel: "=",
        disabled: "<",
    };

    public template: string;

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    constructor() {
        this.template = `<select aa-field-group="ngModel"
                                 aa-label="{{irLabel | translate}}"
                                 ng-disabled="disabled">
                            <option ng-if="!hideDefault" value="">
                                {{(defaultText || 'Gui.Common.NoneSelected') | translate}}
                            </option>
                        </select>`;
    }
}

module("mmGui").directive("irInputSelect", [() => new InputSelectDirective()]);
